import {
  EditOutlined,
  HomeOutlined,
  FileDoneOutlined,
  FileAddOutlined,
  FileTextOutlined,
  DollarCircleOutlined,
} from '@ant-design/icons';
import { RiHealthBookLine } from 'react-icons/ri';
import { IClient } from '../../shared/interfaces';
import { DropdownOptions } from '../DropdownOptions';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LiaToothSolid } from 'react-icons/lia';
import { useAuth } from '../../hooks/auth';
import { PermissionActions } from '../../shared/enums/permissions.enum';
import { Screens } from '../../shared/enums/screens.enum';

interface IOptionsClientProps {
  client: IClient;
  size?: 'large' | 'middle' | 'small';
}

export const OptionsClient: React.FC<IOptionsClientProps> = ({
  client,
  size,
}) => {
  const navigate = useNavigate();
  const { permissionFind, screenFind } = useAuth();

  const loadOptions = () => {
    const listOptions = [
      permissionFind([PermissionActions.clientsUpdate])
        ? {
            label: 'Editar',
            key: '1',
            icon: <EditOutlined />,
            onClick: () => navigate(`/clients/${client.id}`),
          }
        : null,
      screenFind([Screens.clientsView])
        ? {
            label: 'Endereços',
            key: '2',
            icon: <HomeOutlined />,
            onClick: () => navigate(`/addresses/${client.id}`),
          }
        : null,
    ];

    if (!client.is_supplier) {
      listOptions.push(
        screenFind([Screens.treatmentsView])
          ? {
              label: 'Orçamentos / Tratamentos',
              key: '3',
              icon: <FileDoneOutlined />,
              onClick: () => navigate(`/treatments/${client.id}`),
            }
          : null,
        screenFind([Screens.odontologyView])
          ? {
              label: 'Odontológico',
              key: '4',
              icon: <LiaToothSolid size={16} />,
              onClick: () => navigate(`/dentals/${client.id}`),
            }
          : null,
        screenFind([Screens.healthCertificatesView])
          ? {
              label: 'Atestados',
              key: '5',
              icon: <FileAddOutlined />,
              onClick: () => navigate(`/health_certificates/${client.id}`),
            }
          : null,
        screenFind([Screens.documentsView])
          ? {
              label: 'Documentos',
              key: '6',
              icon: <FileTextOutlined />,
              onClick: () => navigate(`/documents/${client.id}`),
            }
          : null,
        screenFind([Screens.formsView])
          ? {
              label: 'Prontuários',
              key: '7',
              icon: <RiHealthBookLine />,
              onClick: () => navigate(`/forms/${client.id}`),
            }
          : null,
        screenFind([Screens.financialsView])
          ? {
              label: 'Ficha Financeira',
              key: '8',
              icon: <DollarCircleOutlined />,
              onClick: () => navigate(`/financials/${client.id}`),
            }
          : null,
      );
    }
    return listOptions;
  };

  return <DropdownOptions items={loadOptions()} size={size} />;
};
